/**
 * Die drei Beschränkungen einer Zeitraum-Zeile — Beschriftung, Erklärung und die Wahl
 * „gleich · setzen · aufheben“ (gleich sendet nichts, aufheben sendet ausdrücklich „aus“).
 *
 * Stehen getrennt von den Wertfeldern, weil Tabelle und Karte sie unterschiedlich anordnen, die
 * Bedeutung aber genau einmal festgelegt sein muss.
 */
import type { RangeControlProps } from './multiRangeControls';
import { rangeScope } from './multiRangeControls';
import type { RestrictionMode } from './multiRangeRowModel';

export const RESTRICTION_MODES: { value: RestrictionMode; label: string }[] = [
  { value: '', label: 'gleich' },
  { value: 'set', label: 'setzen' },
  { value: 'clear', label: 'aufheben' },
];

export const RESTRICTIONS = [
  {
    key: 'closedToArrival',
    label: 'Keine Anreise',
    hint: 'An diesen Tagen darf kein Aufenthalt beginnen.',
  },
  {
    key: 'closedToDeparture',
    label: 'Keine Abreise',
    hint: 'An diesen Tagen darf kein Aufenthalt enden.',
  },
  {
    key: 'stopSell',
    label: 'Verkaufsstopp',
    hint: 'Komplette Sperre für die Buchungsportale, ohne die Verfügbarkeit zu ändern.',
  },
] as const;

export function RangeRestrictionCheck({
  row,
  index,
  onChange,
  disabled,
  field,
}: RangeControlProps & { field: (typeof RESTRICTIONS)[number] }) {
  return (
    <RestrictionModeSelect
      value={row[field.key]}
      onChange={(mode) => onChange({ [field.key]: mode })}
      disabled={disabled}
      label={`${rangeScope(index)}: ${field.label}`}
      hint={field.hint}
    />
  );
}

/** Natives Auswahlfeld: kompakt in Tabellenzeilen, mit 44 px Höhe auch am Handy bedienbar. */
export function RestrictionModeSelect({
  value,
  onChange,
  disabled,
  label,
  hint,
}: {
  value: RestrictionMode;
  onChange: (mode: RestrictionMode) => void;
  disabled?: boolean;
  label: string;
  hint?: string;
}) {
  return (
    <select
      value={value}
      onChange={(event) => onChange(event.target.value as RestrictionMode)}
      disabled={disabled}
      aria-label={label}
      title={hint}
      className="border-line bg-card text-ink rounded-control min-h-11 border px-2 text-xs"
    >
      {RESTRICTION_MODES.map((mode) => (
        <option key={mode.value} value={mode.value}>
          {mode.label}
        </option>
      ))}
    </select>
  );
}
